export default __webpack_public_path__ + "static/media/Giuria (4).9ad6058a.jpg";